export default {
  namespaced: true,
  state: {
    /** 全部课程 */
    mainCourse: null,
    /** 我的课程 */
    myCourse: null,
    /** 我的搜索历史 */
    searchHistoryList: [],
  },
  mutations: {
    SET_MAIN_COURSE(state, payload) {
      state.mainCourse = payload;
    },
    SET_MY_COURSE(state, payload) {
      state.myCourse = payload;
    },
    ADD_SEARCH_HISTORY(state, payload) {
      const index = state.searchHistoryList.indexOf(payload);
      if (index > -1) {
        state.searchHistoryList.splice(index, 1);
      }
      state.searchHistoryList.unshift(payload);
      const count = state.searchHistoryList.length;
      state.searchHistoryList.splice(20, count);
    },
    CLEAR_SEARCH_HISTORY(state) {
      state.searchHistoryList = [];
    },
  },
};
